import React from "react";
import { message, Modal, Spin } from "antd";
import moment from "moment";
const STATUS_LOADING = 0; // 还没有图片
const STATUS_READY = 1; // 图片渲染完成,可以开始滑动
const STATUS_MATCH = 2; // 图片位置匹配成功
const STATUS_ERROR = 3; // 图片位置匹配失败
// 278 * 285
class _FpCaptcha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgSrc: "",
            showInfo: false,
            isMovable: false,
            startX: 0, // 开始滑动的 x
            startY: 0, // 开始滑动的 y
            currX: 0, //当前的 x
            currY: 0, // 当前的 y
            status: STATUS_LOADING,
            verifyStatue: "0", //(0:未验证,1:验证成功，2:验证失败)
        };
        this.canvas = null;
        this.ctx = null;
        this.img = null;
        this.options = {
            col: 10,
            row: 2,
            chartUri: "",
            shuffleMatrix: [],
        };
        this.allowRefresh = true;
    }

    componentDidUpdate(prevProps) {
        if (
            !!this.props.chartUri &&
            prevProps.chartUri !== this.props.chartUri
        ) {
            this.setState(
                {
                    chartUri: this.props.chartUri,
                    keyUri: this.props.keyUri,
                    shuffleMatrix: this.props.shuffleMatrix,
                },
                () => {
                    // let { chartUri, keyUri, shuffleMatrix } = this.state;
                    this.createCanvas();
                    this.renderImage({
                        chartUri: this.props.chartUri,
                        keyUri: this.props.keyUri,
                        shuffleMatrix: this.props.shuffleMatrix
                    });
                }
            );
        }
        if (prevProps.visible !== this.props.visible && !this.props.visible) {
            this.onReset();
        }
    }
    //创建canvas
    createCanvas() {
        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");
        // Do not set width/height here; set after image loads
    }
    async renderImage(options) {
        this.options = { ...this.options, ...options };
        try {
            await this.loadImage();
            this.splitImg();
        } catch (e) {
            console.log(e);
        }
    }
    loadImage = () => {
        return new Promise((resolve, reject) => {
            var image = new Image();
            image.crossOrigin = "";
            image.src = this.options.chartUri;
            image.onload = (e) => {
                this.img = image;
                // Set canvas size to match image size
                this.canvas.width = image.width;
                this.canvas.height = image.height;
                resolve(e);
            };
            image.onerror = (e) => {
                reject(e);
            };
        });
    };
    splitImg() {
        // 切割图片
        let list = [];
        for (let y = 0; y < this.options.row; y++) {
            for (let x = 0; x < this.options.col; x++) {
                let simpleWidth = parseInt(this.img.width / this.options.col);
                let simpleHeight = parseInt(this.img.height / this.options.row);
                list.push({
                    x: x * simpleWidth,
                    y: y * simpleHeight,
                    width: simpleWidth,
                    height: simpleHeight,
                });
            }
        }
        let sortList = this.sortList(list);
        this.setImgBase64(sortList);
    }
    sortList(list) {
        // 图片排序
        list.forEach((element, i) => {
            element.index = this.options.shuffleMatrix[i];
        });
        let newlist = list.sort((param1, param2) => {
            return param1.index - param2.index;
        });
        return newlist;
    }
    async setImgBase64(list) {
        try {
            await this.drawImg(list);
            const base64 = this.canvas.toDataURL();
            this.setState({
                imgSrc: base64,
                status: STATUS_READY,
            });
            this.props.setLoading(false);
        } catch (e) {
            console.log(e);
        }
    }
    drawImg(list) {
        // 绘制图片
        // 清空画布
        if (this.ctx) {
            this.ctx.clearRect(0, 0, 300, 150);
        }
        for (let k = 0; k < list.length; k++) {
            let object = list[k];
            let dx, dy;
            if (k > 9) {
                dx = (k - 10) * 30;
                dy = 75;
            } else {
                dx = (k - 0) * 30;
                dy = 0;
            }
            if (this.ctx) {
                this.ctx.drawImage(
                    this.img,
                    object.x,
                    object.y,
                    object.width,
                    object.height,
                    dx,
                    dy,
                    object.width,
                    object.height
                );
            }
        }
    }
    handleDragStart = (clientX, clientY) => {
        if (this.state.status !== STATUS_READY) {
            return false;
        }
        const startTime = moment();
        this.setState({
            isMovable: true,
            startX: clientX,
            startY: clientY,
            startTime: startTime,
        });
        return true;
    }

    handleDrag = (clientX, clientY) => {
        if (this.state.status !== STATUS_READY || !this.state.isMovable) {
            return;
        }
        const distanceX = clientX - this.state.startX;
        let currX = distanceX;

        const distanceY = clientY - this.state.startY;
        let currY = distanceY;

        const minX = 0;
        const minY = 0;
        const maxX = 300 - 60;
        const maxY = 150 - 60;

        currX = currX < minX ? 0 : currX > maxX ? maxX : currX;
        currY = currY < minY ? 0 : currY > maxY ? maxY : currY;

        this.setState({ currX, currY });
    }

    handleDragEnd = () => {
        if (this.state.status !== STATUS_READY || !this.state.isMovable) {
            return;
        }
        const { startTime } = this.state;
        const nowTime = moment();
        const cost = new Date(nowTime).getTime() - new Date(startTime).getTime();

        this.setState({ isMovable: false });
        
        document.onmousemove = null;
        document.onmouseup = null;
        document.ontouchmove = null;
        document.ontouchend = null;
        
        this.props.judgement(
            {
                x: this.state.currX,
                y: this.state.currY,
                cost: cost,
            },
            this.judgeResult
        );
    }

    onMouseDownEvent = (e) => {
        if (this.handleDragStart(e.clientX, e.clientY)) {
            document.onmousemove = (event) => {
                event.preventDefault();
                this.handleDrag(event.clientX, event.clientY);
            };
            document.onmouseup = (event) => {
                event.preventDefault();
                this.handleDragEnd();
            };
        }
    };

    onTouchStartEvent = (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        if (this.handleDragStart(touch.clientX, touch.clientY)) {
            document.ontouchmove = (event) => {
                this.handleDrag(event.touches[0].clientX, event.touches[0].clientY);
            };
            document.ontouchend = () => {
                this.handleDragEnd();
            };
        }
    }
    judgeResult = (code) => {
        if (["10001", "10002", "11001"].includes(String(code))) {
            this.setState({ verifyStatue: "1" });
            setTimeout(() => {
                this.props.onMatch(this.props.challengeUuid);
                this.setState({ verifyStatue: "0" });
            }, 3000);
        } else {
            this.setState({ verifyStatue: "2" });
            const timer = setTimeout(() => {
                this.allowRefresh = false;
                this.resetPosition();
                if (code == "63403") {
                    //超过解答上限
                    this.props.onReload();
                }
                clearTimeout(timer);
            }, 2000);
        }
    };
    resetPosition = () => {
        this.setState({
            currX: 0,
            currY: 0,
            status: STATUS_READY,
            verifyStatue: "0",
        });
    };
    onRefresh = () => {
        if (this.allowRefresh == false) {
            //防惡意刷新
            message.error('Thao tác này quá thường xuyên, vui lòng thử lại sau.', 3);
            setTimeout(() => {
                this.allowRefresh = true;
            }, 2000);
            return;
        }
        this.allowRefresh = false;
        this.onReset();
        this.props.onReload();
    };
    onReset = () => {
        this.canvas = null;
        this.ctx = null;
        this.img = null;
        this.setState({
            imgSrc: "",
            isMovable: false,
            startX: 0,
            startY: 0, // 开始滑动的 x
            currX: 0, // 滑块当前 x,
            currY: 0, // 滑块当前 x,
            status: STATUS_LOADING,
        });
    };
    onShowInfo = () => {
        this.setState({ showInfo: !this.state.showInfo });
    };
    render() {
        const { imgSrc, showInfo, verifyStatue, keyUri } = this.state;
        const { visible, loading, currentLocale } = this.props;
        console.log("visibel", this.props, visible)
        return (
            <React.Fragment>
                <Modal
                    centered
                    closable={true}
                    width={332}
                    footer={null}
                    visible={visible}
                    maskClosable={false}
                    keyboard={false}
                    onCancel={() => {
                        this.props.setVisible(false);
                    }}
                    className="fpcaptch-modal"
                    zIndex={2002}
                >
                    <Spin spinning={loading && !imgSrc} tip={'Đang tải, vui lòng đợi…'}>
                        {/* 加载中，请稍后... */}
                        <div className="fpcontent">
                            <p
                            style={{
                                fontSize: "14px",
                                marginRight: "35px",
                                position: "absolute",
                                top: "10px"
                            }}
                            >{currentLocale && currentLocale.info}</p>
                            {/* 请拖动左边滑块，来完成拼图 */}
                            <div
                                className="fpSection"
                                style={{
                                    background: imgSrc
                                        ? `url(${imgSrc}) no-repeat`
                                        : "#eee",
                                }}
                            >
                                <div
                                    className="moveElement"
                                    id="moveElement"
                                    style={{
                                        background:
                                            imgSrc && keyUri
                                                ? `url(${keyUri}) no-repeat`
                                                : "#eee",
                                        left: this.state.currX + "px",
                                        top: this.state.currY + "px",
                                    }}
                                    onMouseDown={(e) =>
                                        this.onMouseDownEvent(e)
                                    }
                                    onTouchStart={(e) => this.onTouchStartEvent(e)}
                                ></div>
                                <div
                                    className="info"
                                    style={{
                                        display: showInfo ? "block" : "none",
                                        marginTop: "45px",
                                        width: "294px",
                                        height: "150px",
                                        overflowY: "scroll",
                                        transform: "translateX(15px)"
                                    }}
                                >
                                    <img
                                        src="/img/icons/icon-closed.png"
                                        onClick={this.onShowInfo}
                                    />
                                    <p>
                                        {/* {currentLocale && currentLocale.description}
                                         */}
                                         Vui lòng nhấn giữ mảnh ghép và trượt mảnh ghép vào vị trí chính xác còn thiếu để hoàn tất. Đã gửi đáp án của bạn, vui lòng đợi kết quả xác minh.
                                        {/* 按住拼图滑块不放，并向右拖动，将图中小方块拖到缺口位置进行拼合；拼图完成后松手，即可通过验证。 */}
                                    </p>
                                </div>
                                <div
                                    className="verifySuccess"
                                    style={{
                                        display:
                                            verifyStatue === "1"
                                                ? "block"
                                                : "none",
                                    }}
                                >
                                    <img src="/img/icons/success.png" />
                                    <span>{'Xác Thực Thành Công'}</span>
                                    {/* 验证成功 */}
                                </div>
                                <div
                                    className="verifyFail"
                                    style={{
                                        display:
                                            verifyStatue === "2"
                                                ? "block"
                                                : "none",
                                    }}
                                >
                                    <img src="/img/icons/fail.png" />
                                    <span>{'Thất bại. Vui lòng thử lại'}</span>
                                </div>
                            </div>
                            <div className="fpFooter">
                                <img
                                    src="/img/icons/icon-refresh.svg"
                                    onClick={this.onRefresh}
                                />
                                <img
                                    src="/img/icons/icon-info.svg"
                                    onClick={this.onShowInfo}
                                />
                            </div>
                        </div>
                    </Spin>
                </Modal>
            </React.Fragment>
        );
    }
}

export default _FpCaptcha;
